module.exports = __webpack_public_path__ + "img/kefu.a191d892.png";